import axios from 'axios';

/**
 * 共有先のログイン
 * @param  {string} uid ユニークID
 * @param {string} password パスワード
 */
export const guestLogin = (uid: string, password: string) => {
  const data = { uid, password };
  return axios
    .post('/api/v1/share/login', data, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      return err.response;
    });
};
